export const getDetailAmount = (detail) => {
  return detail.reduce((total, element) => {
    return total + (element.totalFob || 0);
  }, 0);
};
